import React, { useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom';
import axios from "axios"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MiniHeaderComponent from "./MiniHeaderComponent"
import logo from "./logo_nav.png"


const HeaderComponent = (props) => {
  let navigate = useNavigate()

  const [username, setUsername] = useState("")
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  

  useEffect(() => {
    const name = localStorage.getItem("username")
    setUsername(name)
  }, [])

  async function handleLogout(event) {
    try {
      event.preventDefault()
      const response = await axios.post("http://18.234.199.102:5000/logout", {headers: {'Access-Control-Allow-Origin' : 'http://frontend-container:3000','Content-Type': 'application/json'}})
      if (response.data.msg === "logout successful") {
        localStorage.removeItem("token")
        localStorage.removeItem("username")
        navigate("/logout")
      }

    } catch (error) {
      console.log(error)
    }
  }
  

  return (
    <div className="header">
        {/* <img className="header__logo" /> */}
        <MiniHeaderComponent />
        {localStorage.getItem("username") && (
          <>
          <div className="header__menu">
            <Button onClick={handleClick} sx = {{color: "#272A31", fontSize: "25px", border: "2px solid black"}} size="large">Menu</Button>
            <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
          </div>
          </>
        )}
    </div>
  );
};
export default HeaderComponent;
